import { useMutation, UseMutationOptions } from "@tanstack/react-query";

import { authClient, betterAuthErrorText } from "lib/auth/authClient";

type GenerateBackupCodesData = { status: boolean; backupCodes: string[] };

// Regenerates the user's backup codes, invalidating any previous set. Requires the password as a
// re-authentication step; returns the fresh codes to display once.
export function useGenerateBackupCodes(
  options?: UseMutationOptions<GenerateBackupCodesData, unknown, { password: string }, unknown>,
) {
  return useMutation({
    mutationFn: async ({ password }: { password: string }): Promise<GenerateBackupCodesData> => {
      const { data, error } = await authClient.twoFactor.generateBackupCodes({ password });
      if (error) {
        throw new Error(betterAuthErrorText(error, "Could not regenerate backup codes"));
      }
      return data;
    },
    ...options,
  });
}
